module.exports = __webpack_public_path__ + "static/media/3DPPA33.6dd7db5a.jpg";